interface Entry {
  id: number | string;
  name: string;
  position: number;
  value: string;
  points?: number | string;
  isAbsent?: boolean;
}

export default function PublicRaceRanking({ entries, valueLabel }: { entries: Entry[]; valueLabel: string }) {
  const showPoints = entries.some(entry => entry.points !== undefined);
  return <div className="ranking-list">
    <div className="ranking-list__header flex items-center gap-3 px-3 py-3 text-xs font-semibold" aria-hidden="true">
      <span className="min-w-0 flex-1">Concorrente</span><span className="w-24 text-right">{valueLabel}</span>{showPoints && <span className="w-14 text-right">Punti</span>}
    </div>
    {entries.map(entry => <div key={entry.id} className="ranking-list__row flex flex-wrap items-center gap-3 px-3 py-4">
      <div className="flex min-w-0 flex-1 items-center gap-2">
        <span className={`ranking-list__position shrink-0 ${!entry.isAbsent ? `ranking-list__position--${entry.position}` : ""}`}>{entry.isAbsent ? "—" : `${entry.position}°`}</span>
        <div className="min-w-0"><span className="block break-words text-sm font-semibold">{entry.name}</span>{entry.isAbsent && <span className="text-xs text-gray-500">Assente</span>}</div>
      </div>
      <span className="w-24 text-right text-sm font-semibold tabular-nums">{entry.value}</span>
      {showPoints && <span className="ranking-list__points w-14 text-right text-sm tabular-nums">{entry.points} pt</span>}
    </div>)}
  </div>;
}
